import getUri from '../utils/getUri';

function getAppInsightsInstrumentationKey() {
    return getUri('AppInsightsConfiguration/GetInstrumentationKey');
}

function getBagDetailsLinkPath(id) {
    return `Common.Airport/Query/BaggageDetails.aspx?baggage_id=${id}`;
}

function getFlightDetailsLinkPath(id) {
    return `Common.Airport/Query/FlightDetails.aspx?flight_id=${id}`;
}

function getContainerDetailsLinkPath(id) {
    return `Common.Airport/Query/ContainerDetails.aspx?container_id=${id}`;
}

function getPassengerDetailsLinkWithBookingIdPath(id) {
    return `Common.Airport/Query/PassengerDetails.aspx?booking_id=${id}`;
}

function getPassengerDetailsLinkWithPassengerIdPath(id) {
    return `Common.Airport/Query/PassengerDetails.aspx?passenger_id=${id}`;
}

function getAirWaybillDetailsLinkPath(id) {
    return `apps/SmartShip/AirWaybillDetails/${id}`;
}

function getCargoPieceDetailsLinkPath(id) {
    return `apps/SmartShip/CargoPieceDetails?id=${id}`;
}

function getLocationDetailsLinkPath(stationId, areaId, locationId, hours) {
    return `apps/SmartBag/TrackingLocation/locationDetails/${stationId}/${areaId}/${locationId}/${hours}`;
}

function getAdvancedSearchLinkWithParametersPath(pageKey) {
    return `AdvancedSearch/${pageKey}`;
}

function getBidsLateralLinkPath(id) {
    return `apps/SmartBag/BidsDisplay?lateralName=${id}`;
}

export {
    getAppInsightsInstrumentationKey,
    getBagDetailsLinkPath,
    getFlightDetailsLinkPath,
    getContainerDetailsLinkPath,
    getPassengerDetailsLinkWithBookingIdPath,
    getPassengerDetailsLinkWithPassengerIdPath,
    getAirWaybillDetailsLinkPath,
    getCargoPieceDetailsLinkPath,
    getLocationDetailsLinkPath,
    getAdvancedSearchLinkWithParametersPath,
    getBidsLateralLinkPath
};
